<template>
  <section class="sport-page">
    <div class="events">
      <SportListSkeleton v-if="!isFullActualLoaded" />
      <SportList v-else :render-full-tree="singleSportTree" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { useFullActualLoaded } from '@st/nuxt-markets-store/composables/useFullActualLoaded'
import { useSportPage } from './useSportPage'

const { isFullActualLoaded } = useFullActualLoaded()

const { singleSportTree } = useSportPage()
</script>

<style scoped>
.sport-page {
  --sport-header-top: 76px;
  --tournament-panel-top: 124px;

  position: relative;
  padding-bottom: var(--spacing-600);

  &::before {
    content: '';

    position: fixed;
    z-index: 9;
    top: 60px;
    right: 0;
    left: 0;

    height: 16px;

    background-color: var(--background-base);
  }
}
</style>
